module.exports = __webpack_public_path__ + "img/108.9c0f0a25.jpg";